import React, { useState } from 'react';
import { HomePage } from './components/HomePage';
import { ChatWidget } from './components/ChatWidget';
import { AdminDashboard } from './components/AdminDashboard';
import { AuthProvider } from './contexts/AuthContext';
import ProtectedRoute from './components/ProtectedRoute';

function App() {
  const [showAdmin, setShowAdmin] = useState(false);

  // Check if URL contains /admin and listen for changes
  React.useEffect(() => {
    const checkPath = () => {
      const isAdminPath = window.location.pathname === '/admin' || window.location.pathname === '/admin/';
      setShowAdmin(isAdminPath);
    };
    
    checkPath(); // Check initial path
    
    // Listen for browser navigation
    window.addEventListener('popstate', checkPath);
    
    // Also listen for pushstate/replacestate events
    const originalPushState = window.history.pushState;
    const originalReplaceState = window.history.replaceState;
    
    window.history.pushState = function(...args) {
      originalPushState.apply(window.history, args);
      setTimeout(checkPath, 0);
    };
    
    window.history.replaceState = function(...args) {
      originalReplaceState.apply(window.history, args);
      setTimeout(checkPath, 0);
    };
    
    return () => {
      window.removeEventListener('popstate', checkPath);
      window.history.pushState = originalPushState;
      window.history.replaceState = originalReplaceState;
    };
  }, []);

  return (
    <AuthProvider>
      {showAdmin ? (
        <ProtectedRoute requireAdmin>
          <AdminDashboard />
        </ProtectedRoute>
      ) : (
        <ProtectedRoute>
          <div className="App">
            <HomePage />
            <ChatWidget />
          </div>
        </ProtectedRoute>
      )}
    </AuthProvider>
  );
}

export default App;